import axios from 'axios';
import { attachTokenRefresh } from '@/utils/authInterceptors';
import { notify } from '@/utils/notify';
import store from '@/store';
import router from '@/router';

const CLOUD_SERVICE_BASE_URL = process.env.VUE_APP_CLOUD_SERVICE_BASE_URL || 'https://api.vibrant-wellness.com/v1';

const pricingService = axios.create({
  baseURL: CLOUD_SERVICE_BASE_URL + (process.env.VUE_APP_ENV === 'production'
    ? '/pricing'
    : '/pricing/staging'
  ),
  timeout: 30000
});

// Request interceptor
pricingService.interceptors.request.use(
  (config) => {
    const token = store.getters['login/token'];
    const userId = store.getters['login/userId'];

    // Pricing API expects Authorization: Bearer ${token}
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (userId) {
      config.headers['X-User-Id'] = userId;
    }

    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
pricingService.interceptors.response.use(
  (response) => {
    if (response.status !== 200 && response.status !== 204) {
      notify({
        type: 'error',
        message: response.message || 'Request failed'
      });
      return Promise.reject(new Error('Request failed'));
    }
    return response;
  },
  (error) => {
    console.error('Response error:', error);

    if (error.response?.status === 401) {
      // Handle unauthorized - clear auth state
      store.dispatch('login/handleAuthError');
      return Promise.reject(error);
    }

    let message = error.message;
    if (error.response?.data) {
      message = error.response.data.error || error.response.data.message || message;
    }

    notify({
      type: 'error',
      message
    });

    return Promise.reject(error);
  }
);

attachTokenRefresh(pricingService);

export default pricingService;
